import { useNavigate } from "react-router-dom";
import { useState, useEffect } from "react";
import { toast } from "react-toastify";
import { Card, Col, Form, Row } from "react-bootstrap";

import { Switch, TextField } from "@mui/material";
import { mdiCheckCircle, mdiKeyboardReturn, mdiPlus } from "@mdi/js";
import InputSemBorda from "../../../../components/Formularios/Inputs/InputsSemBorda";
import { Button } from "../../../../components/Formularios/Buttons/Button";
import ModalLoading from "../../../../components/Formularios/Modal/ModalLoading";
import ApiGet from "../../../../api/endPoints/useGet";
import { TextoFormatoCaptalize } from "../../../../components/Auxiliar/ConvTextoCaptalize";
import ApiPost from "../../../../api/endPoints/usePost";
import ApiPut from "../../../../api/endPoints/usePut";
import { ITabela } from "../../../../components/Formularios/Table/TabelaInterface";
import Tabela from "../../../../components/Formularios/Table";
import ModalDetalhe from "../modalDetalheCodigoSistema";
import { TextoFormatoUpperCaseAcento } from "../../../../components/Auxiliar/ConvTextUpperRemCaracEspAcento";
import { showConfirmationDialog } from "../../../../components/Formularios/Modal/ModalExcluir";
import ApiDelete from "../../../../api/endPoints/useDelete";
import { getSessionData } from "../../../../utils/storageUtils";
import { Box } from "@mui/material";
import { useForm } from "react-hook-form";
import { endpointPrincipal } from "../../../../api/endPoints/endpointPrincipal/endpointPrincipal";

interface CodSistemaInterface {
  id?: string;
  tabela: string;
  descricao: string;
  situacao: number;
  itens?: any[];
}

interface CodSistemaDetalheInterface {
  codigo: string;
  descricao: string;
  defusr01?: string;
  defusr02?: string;
  defusr03?: string;
  defusr04?: string;
  defusr05?: string;
  defusr06?: string;
  situacao: number;
}

interface FormPerfilProps {
  idcodigo?: string;
  acao?: string;
}

const FormCodSistema = ({ idcodigo, acao }: FormPerfilProps) => {
  const { register, handleSubmit, setValue, watch } = useForm<CodSistemaInterface>();
  const navigate = useNavigate();
  const token = getSessionData("xc-helpdesk-token") || "";

  // Define se está no modo de visualização
  const isVisualizando = acao === 'Visualizar';

  const [loading, setLoading] = useState<boolean>(false);
  const [dados, setDados] = useState<CodSistemaDetalheInterface[]>([]);
  const [ativo, setAtivo] = useState<boolean>(true);
  const [showModalDetalhe, setShowModalDetalhe] = useState<boolean>(false);
  const [dadosItens, setDadosItens] = useState({
    codigo: "",
    descricao: "",
    defUsuario01: "",
    defUsuario02: "",
    defUsuario03: "",
    defUsuario04: "",
    defUsuario05: "",
    defUsuario06: "",
    ativo: true,
    acao: "",
  });

  const carregarDados = async (tabela: string) => {
    setLoading(true);
    try {
      const { data } = await endpointPrincipal.get(`/codigosistema/${tabela}`);
      setValue("id", data.id);
      setValue("tabela", data.tabela);
      setValue("descricao", data.descricao);
      setAtivo(data.situacao === 1);
      setDados(data.detalhes || []);
    } catch (erro: any) {
      const msg = erro.response?.data.message || erro.message;
      toast.error(`Erro ao carregar dados. Motivo: ${msg}`);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (idcodigo && idcodigo !== "novo") {
      carregarDados(idcodigo);
    }
  }, [idcodigo]);

  useEffect(() => {
    setValue("situacao", ativo ? 1 : 0);
  }, [ativo, setValue]);

  //#region REALIZA REQUISIÇÃO PARA ATUALIZAR OS DADOS
  const atualizarDados = async (tabela: string, dto: any) => {
    try {
      const { data } = await endpointPrincipal.put(`/codigosistema/${tabela}`, dto);
      toast.success(data.message);
      setTimeout(() => navigate(-1), 2000);
    } catch (erro: any) {
      const msg = erro.response?.data.message || erro.message;
      toast.error(`Erro ao atualizar dados. Motivo: ${msg}`);
    }
  };

  //#region REALIZA REQUISIÇÃO PARA GRAVAR OS DADOS
  const gravarDados = async (dto: any) => {
    try {
      const { data } = await endpointPrincipal.post("/codigosistema", dto);
      toast.success(data.message);
      setTimeout(() => navigate(-1), 2000);
    } catch (erro: any) {
      const msg = erro.response?.data.message || erro.message;
      toast.error(`Erro ao gravar dados. Motivo: ${msg}`);
    }
  };

  const onSubmit = (formData: CodSistemaInterface) => {
    const itensComTabela = dados.map(item => ({
      ...item,
      tabela: formData.tabela.toUpperCase()
    }));

    const dto = {
      ...formData,
      tabela: formData.tabela.toUpperCase(),
      situacao: ativo ? 1 : 0,
      itens: itensComTabela
    };

    if (idcodigo === "novo" || !idcodigo) {
      gravarDados(dto);
      toast.info("Inserindo novo registro...");
    } else {
      atualizarDados(formData.tabela, dto);
      toast.info("Atualizando dados do registro...");
    }
  };

  const colunas: ITabela[] = [
    { titulo: "Código", acesso: "codigo" },
    { titulo: "Descrição", acesso: "descricao" },
    { titulo: "Def. Usuário 1", acesso: "defusr01" },
    { titulo: "Def. Usuário 2", acesso: "defusr02" },
    { titulo: "Def. Usuário 3", acesso: "defusr03" },
    { titulo: "Def. Usuário 4", acesso: "defusr04" },
    { titulo: "Def. Usuário 5", acesso: "defusr05" },
    { titulo: "Def. Usuário 6", acesso: "defusr06" },
    { titulo: "Situação", acesso: "situacao" },
  ];

  const visualizar = (dadosVisualizar: any) => {
    setDadosItens((state) => {
      return {
        ...state,
        codigo: dadosVisualizar.codigo,
        descricao: dadosVisualizar.descricao,
        defUsuario01: dadosVisualizar.defusr01,
        defUsuario02: dadosVisualizar.defusr02,
        defUsuario03: dadosVisualizar.defusr03,
        defUsuario04: dadosVisualizar.defusr04,
        defUsuario05: dadosVisualizar.defusr05,
        defUsuario06: dadosVisualizar.defusr06,
        ativo: dadosVisualizar.situacao === 1 ? true : false,
        acao: "Visualizar",
      };
    });
    setShowModalDetalhe(true);
  };

  const editar = (dadosEditar: any) => {
    setDadosItens((state) => {
      return {
        ...state,
        codigo: dadosEditar.codigo,
        descricao: dadosEditar.descricao,
        defUsuario01: dadosEditar.defusr01,
        defUsuario02: dadosEditar.defusr02,
        defUsuario03: dadosEditar.defusr03,
        defUsuario04: dadosEditar.defusr04,
        defUsuario05: dadosEditar.defusr05,
        defUsuario06: dadosEditar.defusr06,
        ativo: dadosEditar.situacao === 1 ? true : false,
        acao: "EditarItem",
      };
    });
    setShowModalDetalhe(true);
  };
  const excluirItem = async (dadosExcluir: any) => {
    const codigo = dadosExcluir.codigo;
    if (acao !== "Visualizar") {
      await showConfirmationDialog(
        "Excluir Código do Sistema",
        `Tem certeza que deseja excluir o código do sistema \n ${dadosExcluir.codigo} - ${dadosExcluir.descricao}?`,
        "question",
        "Excluir",
        "Cancelar"
      )
        .then(async (resultado) => {
          if (resultado.confirmed) {
            if (acao === "Novo") {
              const dadosNovos = dados.filter(
                (item: any) => item.codigo !== codigo
              );
              setDados(dadosNovos);
              toast.success("Código excluído com sucesso!");
            } else if (acao === "Editar") {
              try {
                const currentTabela = watch("tabela");
                const { data } = await endpointPrincipal.delete(`/codigosistema/${currentTabela}/detalhe/${codigo}`);
                toast.success(data.message);
                carregarDados(currentTabela);
              } catch (erro: any) {
                const msg = erro.response?.data.message || erro.message;
                toast.error(`Erro ao excluir registro. Motivo: ${msg}`);
              }
            }
          }
        })
        .catch((erro: any) => {
          const msg = erro.response?.data.message || erro.message;
          toast.error(`Erro ao excluir dados. Motivo: ${msg}`);
        });
    }
  };

  const handleOpenModal = () => {
    //Limpar Campos do Modal
    setDadosItens({
      codigo: "",
      descricao: "",
      defUsuario01: "",
      defUsuario02: "",
      defUsuario03: "",
      defUsuario04: "",
      defUsuario05: "",
      defUsuario06: "",
      ativo: true,
      acao: "Novo",
    });

    setShowModalDetalhe(true);
  };
  const handleCloseModal = () => {
    // Simulação: Buscar dados de um GET ou preparar valores iniciais
    setShowModalDetalhe(false);
  };

  const handleSubmitForm = async (dadosItens: any) => {
    const currentTabela = watch("tabela");
    const dadosTabela = {
      tabela: currentTabela.toUpperCase(),
      codigo: dadosItens.codigo.toUpperCase(),
      descricao: dadosItens.descricao,
      defusr01: dadosItens.defUsuario01,
      defusr02: dadosItens.defUsuario02,
      defusr03: dadosItens.defUsuario03,
      defusr04: dadosItens.defUsuario04,
      defusr05: dadosItens.defUsuario05,
      defusr06: dadosItens.defUsuario06,
      situacao: dadosItens.ativo ? 1 : 0,
    };

    try {
      if (acao === "Novo" && dadosItens.acao === "Novo") {
        const item = dados.some((item) => item.codigo === dadosItens.codigo);
        if (!item) {
          setShowModalDetalhe(false);
          setDados([...dados, dadosTabela]);
        } else {
          toast.error("Código já cadastrado na tabela!");
        }
      } else if (acao === "Editar" && dadosItens.acao === "Novo") {
        const item = dados.some((item) => item.codigo === dadosItens.codigo);
        if (!item) {
          const { data } = await endpointPrincipal.post(`/codigosistema/${currentTabela}/detalhe`, dadosTabela);
          toast.success(data.message);
          carregarDados(currentTabela);
          setShowModalDetalhe(false);
        } else {
          toast.error("Código já cadastrado na tabela!");
        }
      } else if (acao === "Editar" && dadosItens.acao === "EditarItem") {
        const { data } = await endpointPrincipal.put(`/codigosistema/${currentTabela}/detalhe/${dadosItens.codigo}`, dadosTabela);
        toast.success(data.message);
        carregarDados(currentTabela);
        setShowModalDetalhe(false);
      }
    } catch (erro: any) {
      const msg = erro.response?.data.message || erro.message;
      toast.error(`Erro ao processar dados. Motivo: ${msg}`);
    }
  };

  return (
    <>
      <Card>
        <Form onSubmit={handleSubmit(onSubmit)}>
          <Card.Body>
            <Box sx={{ width: "100%" }}>
              <Row>
                <Col sm={2}>
                  <TextField
                    sx={{
                      width: "100%",
                      mb: 3,
                      "& .MuiInputBase-input.Mui-disabled": {
                        backgroundColor: "rgba(242, 242, 242, 0.50)"
                      }
                    }}
                    id="outlined-basic"
                    label="Cód. Tabela"
                    size="small"
                    {...register("id")}
                    InputLabelProps={{
                      shrink: true,
                    }}
                    disabled
                  />
                </Col>
                <Col sm={3}>
                  <TextField
                    sx={{ width: "100%", mb: 3 }}
                    id="outlined-basic"
                    label="Tabela"
                    size="small"
                    {...register("tabela", { required: true })}
                    InputLabelProps={{
                      shrink: true,
                    }}
                    required
                    disabled={isVisualizando || acao === "Editar"}
                    inputProps={{
                      style: { textTransform: 'uppercase' }
                    }}
                  />
                </Col>
                <Col sm={5}>
                  <TextField
                    sx={{ width: "100%", mb: 3 }}
                    id="outlined-basic"
                    label="Descrição"
                    size="small"
                    {...register("descricao", { required: true })}
                    InputLabelProps={{
                      shrink: true,
                    }}
                    required
                    disabled={isVisualizando}
                  />
                </Col>
                <Col sm={2}>
                  <label htmlFor="" className="form-label me-2">
                    Ativo
                  </label>
                  <Switch
                    checked={ativo}
                    onChange={(e) => {
                      setAtivo(e.target.checked);
                      setValue("situacao", e.target.checked ? 1 : 0);
                    }}
                    disabled={isVisualizando}
                  />
                </Col>
              </Row>
              <hr />
              <Row>
                <Col sm={2}>
                  <Button
                    type="button"
                    className="btn btn-primary rounded-2 d-flex align-items-center gap-1"
                    descricaoBotao="Incluir Código"
                    icone={mdiPlus}
                    onclick={handleOpenModal}
                    disabled={isVisualizando}
                  />
                </Col>
              </Row>
              <hr />
              <Row>
                <Tabela
                  coluna={colunas}
                  itemsPerPage={5}
                  dados={dados}
                  onVisuClick={visualizar}
                  onEditClick={isVisualizando ? () => {} : editar}
                  onDeleteClick={isVisualizando ? () => {} : excluirItem}
                  onImprimirClick={() => { }}
                  usaImprimir={false}
                />
              </Row>
            </Box>
          </Card.Body>
          <Card.Footer>
            <div className="d-flex my-2 gap-1 justify-content-between">
              <Button
                type="button"
                className="btn btn-outline-secondary rounded-2 d-flex align-items-center gap-1"
                descricaoBotao="Voltar"
                icone={mdiKeyboardReturn}
                onclick={() => {
                  navigate(-1);
                }}
              />
              <Button
                type="submit"
                className="btn btn-success rounded-2 d-flex align-items-center gap-1"
                descricaoBotao="Salvar"
                icone={mdiCheckCircle}
                disabled={isVisualizando}
              />
            </div>
          </Card.Footer>
        </Form>
      </Card>
      <ModalLoading show={loading} label="Carregado dados do perfil ..." />

      {/* MODAL PARA INCLUIR/EDITAR ITEM NA TABELA */}

      <ModalDetalhe
        showModal={showModalDetalhe}
        onClose={handleCloseModal}
        onSubmit={handleSubmitForm}
        acao={dadosItens.acao}
        dadosCodigo={dadosItens.codigo}
        dadosDescricao={dadosItens.descricao}
        dadosDefUsuario01={dadosItens.defUsuario01}
        dadosDefUsuario02={dadosItens.defUsuario02}
        dadosDefUsuario03={dadosItens.defUsuario03}
        dadosDefUsuario04={dadosItens.defUsuario04}
        dadosDefUsuario05={dadosItens.defUsuario05}
        dadosDefUsuario06={dadosItens.defUsuario06}
        dadosAtivo={dadosItens.ativo}
      />
    </>
  );
};
export default FormCodSistema;
